import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import template from './text.pug';

export class ColumnAssetType extends CampaignuiBaseColumn {
  constructor({
    i18n, scope,
  }) {
    const title = i18n.getString('ColumnName_AssetType');

    const adType = scope && scope.values && scope.values.adType;

    const helpId = {
      ResponsiveSearch: 'pop_BA_RSA_AssetType',
      Responsive: 'pop_BA_MMA_AssetType',
      DynamicSearch: 'pop_BA_DSA_Asset_type',
      DynamicResponsive: 'pop_BA_DSA_Asset_type',
    };

    super({
      name: 'AssociationType',
      property: 'AssociationType',
      sortable: 'AssociationType',
      title,
      type: 'string',
      bodyClasses: 'grid-column-AssetType',
      helpId: helpId[adType],
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.schemaI18n = new SchemaI18n({ i18n });
  }

  get property() {
    return {
      get: ({
        AssociationType,
      }) => AssociationType,
    };
  }

  template({ value }) {
    const associationType = value.includes('VideoMedia') ? 'VideoMedia' : value;
    return template({
      text: this.schemaI18n.enum('AssociationType', associationType),
    });
  }
}
